import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  LINKEDIN,
  META,
} from "./adsPlatformIds.js";

export const shouldAddCreatingInstantFormLoaderStep = ({
  platform,
  objective,
  destinationType,
}) => {
  if (objective !== ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION) return false;
  if (platform === LINKEDIN) return true;
  if (platform === META) {
    return (
      destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION
    );
  }
  return false;
};

export const buildCampaignGeneratingLoaderLabels = ({
  labels,
  creatingInstantFormLabel,
  platform,
  objective,
  destinationType,
}) => {
  if (
    !shouldAddCreatingInstantFormLoaderStep({
      platform,
      objective,
      destinationType,
    }) ||
    !creatingInstantFormLabel
  ) {
    return labels;
  }

  if (!Array.isArray(labels) || labels.length === 0) {
    return [creatingInstantFormLabel];
  }

  return [
    ...labels.slice(0, -1),
    creatingInstantFormLabel,
    labels[labels.length - 1],
  ];
};
